module.exports = "/images/maximize-sale-price.png?96379ad789f52b0099d287783af9aa2c";